export default __webpack_public_path__ + "static/media/TASKS.104ed05d.jpg";